<script lang="ts">
  import { account } from './account.svelte'

  // Shown only under `vite dev`. Release builds drop this whole block.
  let who = $state('')
  const quick = ['a', 'b', 'c']
</script>

{#if import.meta.env.DEV && account.available}
  <div class="notice notice--warn stack" style="gap: 8px">
    <strong>Dev: sign in without Google</strong>
    <span>
      Any name makes a local test user (<code>dev-name@sofa.test</code>). Or open any page with
      <code>?devuser=name</code>. The signal server needs
      <code>SSHARE_AUTH_PROVIDERS=google,discord,email</code>.
    </span>
    <form
      class="row"
      onsubmit={(event) => {
        event.preventDefault()
        void account.signInAsTestUser(who)
      }}
    >
      <input bind:value={who} placeholder="name, e.g. alice" aria-label="Test user name" />
      <button type="submit" disabled={account.busy || who.trim() === ''}>Sign in</button>
      {#each quick as name (name)}
        <button type="button" disabled={account.busy} onclick={() => account.signInAsTestUser(name)}
          >{name}</button
        >
      {/each}
    </form>
  </div>
{/if}
